"use client";
import dynamic from "next/dynamic";
import React, { useEffect, useState, useLayoutEffect } from "react";
import { useMovementDetection } from "@/components/useMouseMovement";
const CartMain = dynamic(() => import("@/components/cart/cart-main"), { ssr: false });
export type CartDisplayType = "cart" | "checkout" | "payment";
import { useSystemConfig } from "@/lib/providers/system-config-provider";
import { useRouter } from "next/navigation";

interface Props {
    displayType?: CartDisplayType;
    radiusStyle: any;
}

const CartMainLoader = ({ displayType, radiusStyle }: Props) => {
    const [showComponent, setShowComponent] = useState(false);
    const hasInteracted = useMovementDetection();
    const display = displayType ?? "cart";
    const router = useRouter();

    useEffect(() => {
        if (display === "cart") {
            router.push("/checkout");
        }
    }, [display, router]);

    useEffect(() => {
        if (hasInteracted) {
            setShowComponent(true);
        }
    }, [hasInteracted]);

    useEffect(() => {
        const timer = setTimeout(() => setShowComponent(true), 1000);
        return () => clearTimeout(timer);
    }, []);

    return display !== "cart" && showComponent ? <CartMain displayType={display} radiusStyle={radiusStyle}/> : null;
};

export default CartMainLoader;
